<template>
  <div class="operation">
    <div class="title">{{$t('meg.operation')}}</div>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Platform Operation Mode</p>
    <div class="mainBox">{{$t('meg.intelligent')}}</div>
    <h1 style="font-size: .375rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: bold;color: #002FA7;margin-top: .425rem;">{{$t('meg.application')}}</h1>
    <div class="moshi"></div>
  </div>
</template>

<script>
</script>

<style scoped>
.title {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    margin-top: .8625rem;
}
.mainBox {
    /* width: 533px; */
    height: .6375rem;
    background: #F7B02D;
    opacity: 1;
    line-height: .6375rem;
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #FFFFFF;
    margin: .75rem 4.5rem;
    margin-bottom: 0;
}
.moshi {
    height: 8.6375rem;
    background: url("../../../assets/newImg/moshi.png") no-repeat;
    background-size: 100% 100%;
    margin-top: .6rem;
}
</style>
